import * as React from "react";
import { UnitPrice, BestPrice } from "@grandvisionhq/common";
import { useFeatureToggles } from "@grandvisionhq/state";
import { isNumber } from "@grandvisionhq/utils";
import { ProductDiscountBadge } from "../../../../../../ProductDiscountBadge/ProductDiscountBadge/ProductDiscountBadge.js";
import { PriceDetail } from "../../../components/PriceDetail/ProductBlock/components/ProductBlockPricing/components/PriceDetail/PriceDetail.js";
import { PriceSuffix } from "../../../components/PriceSuffix/ProductBlock/components/ProductBlockPricing/components/PriceSuffix/PriceSuffix.js";
/* empty css                         */
const ProductBlockPricing = ({
  originalPrice,
  discountedPrice,
  discountLabel,
  discountValue,
  isCentAmount,
  currency,
  pricePerUnit,
  pricePerUnitFixedDecimals,
  bestPrice,
  hasPriceSuffix = false
}) => {
  const { isPricePerUnitEnabled, isBestPriceEnabled } = useFeatureToggles();
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-pricing" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    PriceDetail,
    {
      originalPrice,
      discountedPrice,
      isCentAmount,
      priceSuffix: hasPriceSuffix ? /* @__PURE__ */ React.createElement(PriceSuffix, null) : void 0
    }
  ), discountValue && /* @__PURE__ */ React.createElement(
    ProductDiscountBadge,
    {
      className: "product-block-pricing__discount",
      label: discountLabel,
      discount: discountValue
    }
  )), isPricePerUnitEnabled && isNumber(pricePerUnit) && /* @__PURE__ */ React.createElement(
    UnitPrice,
    {
      amount: pricePerUnit,
      fixedDecimals: pricePerUnitFixedDecimals,
      currencyCode: currency,
      isCentAmount
    }
  ), isPricePerUnitEnabled && isNumber(bestPrice) && /* @__PURE__ */ React.createElement(
    BestPrice,
    {
      isFeatureEnabled: isBestPriceEnabled,
      bestPriceAmount: bestPrice,
      originalPrice,
      discountedPrice,
      isCentAmount,
      currencyCode: currency
    }
  ));
};
export {
  ProductBlockPricing
};
//# sourceMappingURL=ProductBlockPricing.js.map
